import type { City } from '../../../domain/types';

export function buildStatusFilterOptions(t: (key: string) => string) {
  return [
    { value: 'all', label: t('common.all') },
    { value: 'active', label: t('common.active') },
    { value: 'inactive', label: t('common.inactive') },
  ];
}

export function buildTypeFilterOptions(t: (key: string) => string) {
  return [
    { value: 'all', label: t('addressbook.filterAll') },
    { value: 'site', label: t('addressbook.filterSite') },
    { value: 'office', label: t('addressbook.filterOffice') },
    { value: 'warehouse', label: t('addressbook.filterWarehouse') },
    { value: 'home', label: t('addressbook.filterHome') },
    { value: 'plant', label: t('addressbook.filterPlant') },
    { value: 'customer', label: t('addressbook.filterCustomer') },
  ];
}

export function buildCityFilterOptions(
  cities: City[],
  t: (key: string) => string,
) {
  const options = cities.map((city) => ({ value: city.id, label: city.name }));
  return [{ value: 'all', label: t('common.all') }, ...options];
}

export function getActiveAddressFilterCount(filter: {
  status?: string;
  type?: string;
  cityId?: string;
}) {
  let count = 0;
  if (filter.status && filter.status !== 'all') count += 1;
  if (filter.type && filter.type !== 'all') count += 1;
  if (filter.cityId) count += 1;
  return count;
}
